import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getCakeBrands, getPictureByKey } from '@/views/custom-layout/api';
export default {
  name: 'brands_selection_config',
  components: {
    draggable: draggable,
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      rules: {
        title: [{
          min: 0,
          max: 4,
          message: '标题长度在0到4个字符之间',
          trigger: 'change'
        }],
        imageurl: [{
          required: true,
          message: '图片不可为空'
        }],
        text_color: [{
          required: true,
          message: '品牌文字颜色不可为空',
          trigger: 'change'
        }],
        brand_show_type: [{
          required: true,
          message: '请选择首页品牌显示模式',
          trigger: 'change'
        }],
        category_id: [{
          required: true,
          message: '菜单不可为空',
          trigger: 'change'
        }],
        brandList: [{
          required: true,
          message: '品牌不可为空',
          trigger: 'change'
        }],
        margin_top: [{
          type: 'number',
          message: '间距必须为数字值',
          trigger: 'change'
        }],
        z_index: [{
          required: true,
          pattern: /^(?:[1-9]|[1-9][0-9])$/,
          message: '请输入1-99之间的整数！'
        }]
      },
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureList: [],
      depot: {},
      bidObj: {},
      list: []
    };
  },
  methods: {
    emitUploadFile: function emitUploadFile(path) {
      this.value.config.imageurl = "".concat(this.$ossurl).concat(path);
    },
    onUpload: function onUpload() {
      this.$refs.uploadBanner.uploadBanner();
    },
    selectPicture: function selectPicture() {
      this.showPictureLibrary = true;
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config.imageurl = path;
      this.showPictureLibrary = false;
    },
    // 获取蛋糕品牌列表
    loadData: function loadData() {
      var _this2 = this;
      getCakeBrands({
        category_id: this.value.config.category_id
      }, this.info.module).then(function (res) {
        _this2.list = res.data;
      });
    },
    // 删除
    deleteBrand: function deleteBrand(index) {
      this.value.config.brandList.splice(index, 1);
    },
    // 切换蛋糕数据源 清空原有选择数据
    changeCategory: function changeCategory(category_id) {
      this.value.config.brandList = [];
      this.bidObj = {};
      category_id && this.loadData();
    },
    // 添加
    addBrand: function addBrand() {
      var _this3 = this;
      if (!this.bidObj.id) {
        this.$message.error('请先选择一个品牌');
        return;
      }
      var data = this.list.find(function (i) {
        return i.id === _this3.bidObj.id;
      });
      this.value.config.brandList.push(data);
      this.bidObj = {};
      this.$refs.form.validateField('brandList');
    }
  },
  created: function created() {
    this.getPicture();
    this.$set(this.value, 'config', _objectSpread({
      title: '',
      imageurl: 'https://res.youlianfuwu.com/mini_program/shop/brands_selection_bg.png',
      text_color: '#8C4300',
      category_id: '',
      brand_show_type: 1,
      //首页品牌显示模式
      bids: [],
      // 后端需要用的选择的品牌ID数组
      brandList: [],
      // 用于排序 & 回显 & 中心区域展示的数据
      margin_top: 15,
      z_index: 2
    }, this.value.config));
    this.value.config.category_id && this.loadData();
  },
  computed: {
    menuListFilter: function menuListFilter() {
      return this.menuList.filter(function (i) {
        return ['cake', 'new_cake', 'cake_store'].includes(i.type);
      });
    }
  },
  watch: {
    'value.config.brandList': function valueConfigBrandList(brandList) {
      this.value.config.bids = brandList === null || brandList === void 0 ? void 0 : brandList.map(function (i) {
        return i.id;
      });
    }
  }
};